import { gql } from '@apollo/client';

import { CreateOfferFragment } from 'buying/graphql/fragments/CreateOfferFragment';

export const SubmitOffer = gql`
  mutation SubmitOffer($offerId: String) {
    buyer {
      submitOffer(input: { id: $offerId }) {
        offer {
          ...CreateOfferFragment
        }
      }
    }
  }
  ${CreateOfferFragment}
`;
